import {
    SET_USER,
    LOGOUT,
    LOGIN_FAILURE,
    CLEAR_ERROR,
    UPDATE_USER_DIAGNOSES,
    BIND_WECHAT,
    UNBIND_WECHAT,
    WECHAT_BINDING_ERROR,
} from '../actionTypes';

const initialState = {
    currentUser: null, // 当前用户信息
    error: null, // 错误信息
    isAuthenticated: false, // 用户是否已认证
    wechatBindingError: null, // 微信绑定错误信息
};

/**
 * 用户相关的 reducer
 * @param {Object} state - 当前状态
 * @param {Object} action - action 对象
 * @returns {Object} 新状态
 */
const userReducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_USER: // 设置用户
            return {
                ...state,
                currentUser: action.payload, // 更新当前用户信息
                isAuthenticated: true, // 用户已认证
                error: null, // 清除错误信息
            };
        case LOGOUT: // 用户登出
            return {
                ...state,
                currentUser: null, // 清除当前用户信息
                isAuthenticated: false, // 用户未认证
                error: null, // 清除错误信息
            };
        case LOGIN_FAILURE: // 登录失败
            return {
                ...state,
                error: action.payload, // 设置错误信息
                isAuthenticated: false, // 用户未认证
            };
        case CLEAR_ERROR: // 清除错误信息
            return {
                ...state,
                error: null, // 清除错误信息
            };
        case UPDATE_USER_DIAGNOSES: // 更新用户舌诊次数
            return {
                ...state,
                currentUser: {
                    ...state.currentUser,
                    surplus: state.currentUser.surplus - action.payload, // 更新剩余次数
                },
            };
        case BIND_WECHAT: // 绑定微信
            return {
                ...state,
                currentUser: {
                    ...state.currentUser,
                    wechatInfo: action.payload, // 更新微信信息
                },
                wechatBindingError: null, // 清除微信绑定错误信息
            };
        case UNBIND_WECHAT: // 解绑微信
            return {
                ...state,
                currentUser: {
                    ...state.currentUser,
                    wechatInfo: null, // 清除微信信息
                },
                wechatBindingError: null, // 清除微信绑定错误信息
            };
        case WECHAT_BINDING_ERROR: // 微信绑定错误
            return {
                ...state,
                wechatBindingError: action.payload, // 设置微信绑定错误信息
            };
        default: // 默认返回当前状态
            return state;
    }
};

export default userReducer;
